import type { PropsWithChildren } from 'react';
import { EndpointsContext } from '../contexts/EndpointsContext';
import { urlFromLocalOrAbsolute } from '../utils';
import { envConfig } from '../utils/envConfig';
import { transformWithApiSubdomain } from '../utils/transformApiUrl';
import { useWLOrgConfigContext } from './WLOrgConfigProvider';

export const EndpointsContextProvider = function EndpointsContextProvider(props: PropsWithChildren) {
  const baseApiEndpoint = urlFromLocalOrAbsolute(envConfig.VITE_API_ENDPOINT);
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const baseWsEndpoint = urlFromLocalOrAbsolute(envConfig.VITE_WS_ENDPOINT, wsProtocol);

  // Try to access the WLOrgConfig context but handle the case when it might not be available
  let useApiSubdomain = false;
  let apiSubdomain = 'api';

  try {
    const wlOrgConfig = useWLOrgConfigContext();
    if (wlOrgConfig && wlOrgConfig.config) {
      useApiSubdomain = wlOrgConfig.config.useApiSubdomain || false;
      apiSubdomain = wlOrgConfig.config.apiSubdomain || 'api';
    }
  } catch (error) {
    // WLOrgConfigContext is not available yet, use default values
    if (import.meta.env.DEV) {
      console.error('WLOrgConfigContext not available yet in EndpointsContextProvider, using default values');
    }
  }

  // Apply the API subdomain transformation if the feature is enabled
  const apiEndpoint = useApiSubdomain
    ? transformWithApiSubdomain(baseApiEndpoint, true, apiSubdomain)
    : baseApiEndpoint;

  const wsEndpoint = useApiSubdomain ? transformWithApiSubdomain(baseWsEndpoint, true, apiSubdomain) : baseWsEndpoint;

  const value = {
    apiEndpoint,
    wsEndpoint,
  };
  return <EndpointsContext.Provider value={value}>{props.children}</EndpointsContext.Provider>;
};
